// extracted by mini-css-extract-plugin
module.exports = {"root":"Dropdown_root__5T-1a","dropdown":"Dropdown_dropdown__1R15V"};